import * as React from "react";
import CustomField from "../../../../../model/customField/CustomField";
import BaseFormView, {BaseFormViewState} from "../../../../ui/form/BaseFormView";
import FormButtonsView from "../../../../ui/form/FormButtonsView";
import ButtonTertiary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import CustomFieldForm from "../CustomFieldForm";
import CustomFieldFormBody from "../CustomFieldFormBody";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {CustomField} editedCustomField edited custom field.
	 */
	onSubmit: (editedCustomField: CustomField) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Custom field to edit.
	 */
	customField: CustomField;
}

type IState = BaseFormViewState<CustomFieldForm>;

export default class EditCustomFieldFormView extends BaseFormView<CustomFieldForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: CustomFieldForm.createFromCustomField(this.props.customField),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<div>
				<CustomFieldFormBody form={this.state.form}
									 onFieldChange={this.onFieldChanged}
									 onFieldCompleted={this.onFieldCompleted}
									 onFocusChange={this.onFocusChange}
									 onFieldsChange={this.onFieldsChanged}
									 editMode/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Update custom field"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit, () => {});
		});
	}
}
